export const EMOTION_EVENTS = {
  SHOW_AND_ANIMATE: 'show_and_animate',
}

export const icons = {
  THUMB_UP: 'thumb_up',
  THUMB_DOWN: 'thumb_down',
  FAVORITE: 'favorite',
  MOOD: 'mood',
}